import React, { Component } from "react";

import {
  Wrapper,
  Copy,
  Spin,
  Button,
  Card,
  Title,
  Bold,
  Icon,
  Row
} from "app/NativeComponents/common";
import { List, PillButton } from "app/NativeComponents/snippets";

import ConversationItem from "./ConversationItem";

class ConversationList extends Component {
  checkIfInActiveConversation(item, active_conversation) {
    if (active_conversation && active_conversation.length > 0) {
      for (let i = 0; i < active_conversation.length; i++) {
        if (active_conversation[i].id == item.id) {
          return true;
        }
      }
    }

    return false;
  }
  render() {
    if (
      (this.props.conversations.length === 0 &&
        this.props.conversations_loading) ||
      this.props.conversations_refreshing
    ) {
      return (
        <Wrapper>
          <Wrapper
            style={{
              padding: 20,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Row>
              <Spin size={"small"} />
              <Copy style={{ marginLeft: 5 }}>Loading Conversations...</Copy>
            </Row>
          </Wrapper>
        </Wrapper>
      );
    }

    if (
      this.props.conversations.length > 0 &&
      !this.props.conversations_refreshing
    ) {
      return (
        <List
          rowNumber={1}
          style={{ flex: 1 }}
          items={this.props.conversations}
          infiniteScroll={true}
          itemStruture={({ item }) => {
            return (
              <ConversationItem
                key={item.id}
                item={item}
                onPress={() => {
                  if (
                    !this.checkIfInActiveConversation(
                      item,
                      this.props.active_conversation
                    ) ||
                    this.props.device == "mobile"
                  ) {
                    this.props.setActiveConversation({
                      token: this.props.token,
                      conversation: item
                    });
                    this.props.appRedirect({
                      redirect: "conversation_item",
                      payload: {
                        conversation_id:
                          this.props.device == "desktop"
                            ? item.conversation_id
                            : null
                      }
                    });
                  }
                }}
                active_conversation={this.props.active_conversation}
                colors={this.props.colors}
                isMobile={this.props.isMobile}
                device={this.props.device}
                token={this.props.token}
                update_conversation_loading={
                  this.props.update_conversation_loading
                }
                updateConversation={this.props.updateConversation}
                dark_mode={this.props.dark_mode}
              />
            );
          }}
          canRefresh={true}
          onRefresh={() => {
            this.props.getTeamConversations(
              "refresh",
              this.props.conversations_search
            );
          }}
          is_refreshing={this.props.conversations_refreshing}
          canLoadMore={
            !this.props.conversations_loaded_all &&
            !this.props.conversations_loading &&
            !this.props.conversationss_refreshing &&
            this.props.conversations.length > 0
          }
          isLoadingMore={
            this.props.conversations_loading &&
            !this.props.conversations_refreshing &&
            this.props.conversations.length > 0
          }
          onLoadMore={() => {
            if (
              !this.props.conversations_loaded_all &&
              this.props.conversations_refreshing !== true &&
              this.props.conversations_loading !== true
            ) {
              this.props.getTeamConversations(
                "load",
                this.props.conversations_search
              );
            }
          }}
        />
      );
    }

    if (this.props.conversations.length === 0) {
      return (
        <Wrapper>
          <Wrapper
            style={{
              padding: 20,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Title
              style={{
                textAlign: "center"
              }}
            >
              No conversations found.
            </Title>
            <Copy
              style={{
                textAlign: "center"
              }}
            >
              No conversations were found matching your criteria.
            </Copy>
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default ConversationList;
